import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Spinner } from "reactstrap";
import axios from "axios";
import Select, { createFilter } from "react-select";
import { API_URL_comision_multi } from "../../../constants";

import { getAuthHeaders, getCurrentUser } from "../../../utils/auth";

class AdminCursoFormCerrado extends React.Component {

  state = {
    pk: 0,
    errorMessage: "",
    admin_del_curso: '',
    adminCostPercentage: '',
    pago_por: 'Admin de Curso Cerrado',
    iva: 0,
    retencion: 0,
    isr: 0,
    subcantidad: 0,
    cantidad: 0,
    instructor: '',
    instructor_code: '',
    comision_multi_code: '',
    moneda: '',
    tipo_cambio: null,
    proyecto_code: '',
    proyecto: '',
    mod_user: '',
    validationErrors: {},
    isSubmitting: false,
  };

  componentDidMount() {
    const { proyectoCode, proyectoName, proyectoMoneda, admin, estudiantesIngreso } = this.props;
    const username = getCurrentUser();

    if (admin) {
      const {
        pk,
        instructor,
        moneda,
        tipo_cambio,
        proyecto,
        proyecto_code,
        comision_multi_code,
        cantidad,
        iva,
        isr,
        retencion,
        subcantidad,
        instructor_code,
      } = admin;

      const ingreso = parseFloat(estudiantesIngreso) || 0;
      const percentage = ingreso > 0
        ? (parseFloat(subcantidad) / ingreso * 100)
        : 0;

      this.setState({
        pk: pk,
        admin_del_curso: instructor,
        instructor: instructor,
        instructor_code: instructor_code || '',
        moneda: moneda || proyectoMoneda || 'USD',
        tipo_cambio: tipo_cambio ?? null,
        proyecto: proyecto,
        proyecto_code: proyecto_code,
        comision_multi_code: comision_multi_code,
        cantidad: cantidad || 0,
        iva: iva || 0,
        isr: isr || 0,
        retencion: retencion || 0,
        subcantidad: subcantidad || 0,
        adminCostPercentage: percentage.toFixed(2),
        mod_user: username,
      });
    } else {
      this.setState({
        proyecto_code: proyectoCode,
        proyecto: proyectoName,
        moneda: proyectoMoneda || 'USD',
        mod_user: username,
      });
    }
  }

  generateRandomString = (length) => {
    const characters = 'ABCDEFGHJKLMNOPQRSTUVWXYZ23456789';
    let random_string = '';
    for (let i = 0; i < length; i++) {
      random_string += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return random_string;
  };

  validateForm = () => {
    const errors = {};
    const { admin_del_curso, adminCostPercentage } = this.state;

    if (!admin_del_curso || admin_del_curso.trim() === '') {
      errors.admin_del_curso = 'Por favor selecciona un admin del curso';
    }

    if (!adminCostPercentage || adminCostPercentage === '') {
      errors.adminCostPercentage = 'Por favor ingresa el porcentaje';
    } else if (parseFloat(adminCostPercentage) < 0 || parseFloat(adminCostPercentage) > 100) {
      errors.adminCostPercentage = 'El porcentaje debe estar entre 0 y 100';
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      validationErrors: {
        ...this.state.validationErrors,
        [name]: null,
      },
    });
  };

  // Build the final payload synchronously — do NOT rely on setState-then-POST,
  // which used to race and drop tax fields on save.
  buildPayload = () => {
    const selectedPartner = (this.props.partners || []).find(
      (p) => p.partner === this.state.admin_del_curso
    );

    const ingreso = parseFloat(this.props.estudiantesIngreso) || 0;
    const percentage = parseFloat(this.state.adminCostPercentage) || 0;
    const subcantidad = ingreso * (percentage / 100);

    let iva = 0;
    let isr = 0;
    let retencion = 0;
    let instructor_code = this.state.instructor_code || '';
    let instructor = this.state.instructor || this.state.admin_del_curso;

    if (selectedPartner) {
      iva = parseFloat(selectedPartner.iva) || 0;
      isr = parseFloat(selectedPartner.isr) || 0;
      retencion = parseFloat(selectedPartner.retencion) || 0;
      instructor_code = selectedPartner.partner_code || instructor_code;
      instructor = selectedPartner.partner || instructor;
    }

    const taxFactor = (iva - retencion - isr) / 100.0;
    const cantidad = subcantidad * (1 + taxFactor);

    return {
      ...this.state,
      instructor,
      instructor_code,
      iva,
      isr,
      retencion,
      subcantidad,
      cantidad,
      moneda: this.state.moneda || this.props.proyectoMoneda || 'USD',
      pago_por: 'Admin de Curso Cerrado',
      proyecto_code: this.state.proyecto_code || this.props.proyectoCode,
      proyecto: this.state.proyecto || this.props.proyectoName,
    };
  };

  scrollToFirstError = () => {
    setTimeout(() => {
      const firstError = document.querySelector('.is-invalid-custom, .is-invalid');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const input = firstError.querySelector('input, select');
        if (input) input.focus();
      }
    }, 100);
  };

  handleServerError = (error) => {
    if (error.response?.data) {
      const serverErrors = error.response.data;
      if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
        this.setState({ validationErrors: serverErrors, isSubmitting: false });
      } else {
        this.setState({
          errorMessage: 'Error al guardar. Por favor verifica los datos.',
          isSubmitting: false,
        });
      }
    } else {
      this.setState({
        errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
        isSubmitting: false,
      });
    }
  };

  createAdmin = async (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      this.scrollToFirstError();
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    try {
      const headers = getAuthHeaders();
      const payload = {
        ...this.buildPayload(),
        comision_multi_code: this.generateRandomString(5),
      };
      await axios.post(API_URL_comision_multi, payload, { headers });
      this.props.resetState();
      this.props.toggle();
    } catch (error) {
      console.error('Error adding Admin de Curso Cerrado:', error);
      this.handleServerError(error);
    }
  };

  editAdmin = async (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      this.scrollToFirstError();
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    try {
      const headers = getAuthHeaders();
      const payload = this.buildPayload();
      const url = `${API_URL_comision_multi}${this.state.pk}/`;
      await axios.put(url, payload, { headers });
      this.props.resetState();
      this.props.toggle();
    } catch (error) {
      console.error('Error updating Admin de Curso Cerrado:', error);
      this.handleServerError(error);
    }
  };

  render() {
    const {
      errorMessage,
      admin_del_curso,
      adminCostPercentage,
      moneda,
      validationErrors,
      isSubmitting,
    } = this.state;
    const { proyectoCode, proyectoName, partners, estudiantesIngreso } = this.props;
    const h3Style = { color: 'blue' };

    const filterOption = createFilter({
      ignoreAccents: true,
      ignoreCase: true,
      trim: true,
      matchFrom: "any",
    });

    const partnerOptions = Array.isArray(partners)
      ? partners.map((p) => ({ value: p.partner, label: p.partner }))
      : [];

    const ingreso = parseFloat(estudiantesIngreso) || 0;
    const percentage = parseFloat(adminCostPercentage) || 0;
    const costoCalculado = ingreso * (percentage / 100);

    const fxRowCurrency = moneda || 'USD';
    const fxProjectCurrency = this.props.proyectoMoneda || 'USD';
    const fxCurrency = fxRowCurrency !== 'USD' ? fxRowCurrency : fxProjectCurrency;
    const showTipoCambio = fxRowCurrency !== 'USD' || fxProjectCurrency !== 'USD';

    return (
      <div>
        <h3>{proyectoName}</h3>
        {proyectoCode && <h3 style={h3Style}>{proyectoCode.toUpperCase()}</h3>}
        <h5>
          Ingreso de estudiantes:{' '}
          {ingreso > 0
            ? ingreso.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '0.00'}
        </h5>

        <div className="form-requirements-note">
          <strong>Nota:</strong> Los campos marcados con <span className="required-asterisk">*</span> son obligatorios.
        </div>

        <Form onSubmit={this.props.admin ? this.editAdmin : this.createAdmin}>
          <FormGroup>
            <Label for="admin_del_curso">
              Admin del Curso<span className="required-asterisk">*</span>
            </Label>
            <Select
              options={partnerOptions}
              value={partnerOptions.find((o) => o.value === admin_del_curso) || null}
              onChange={(opt) => {
                this.setState({
                  admin_del_curso: opt ? opt.value : "",
                  validationErrors: { ...validationErrors, admin_del_curso: null },
                });
              }}
              placeholder="Seleccionar Admin..."
              isClearable
              filterOption={filterOption}
              className={validationErrors.admin_del_curso ? 'is-invalid' : ''}
            />
            {validationErrors.admin_del_curso && (
              <div className="invalid-feedback-custom">{validationErrors.admin_del_curso}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="adminCostPercentage">
              Porcentaje<span className="required-asterisk">*</span>
            </Label>
            <Input
              type="number"
              name="adminCostPercentage"
              onChange={this.onChange}
              value={adminCostPercentage}
              step="0.01"
              min="0"
              max="100"
              placeholder="Ej: 10 para 10%"
              className={validationErrors.adminCostPercentage ? 'is-invalid-custom' : ''}
            />
            {validationErrors.adminCostPercentage && (
              <div className="invalid-feedback-custom">{validationErrors.adminCostPercentage}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="moneda">Moneda (desde proyecto):</Label>
            <Input
              type="text"
              name="moneda"
              value={moneda || 'USD'}
              disabled
              style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
            />
            <small className="form-text text-muted">
              La moneda se hereda del proyecto y no se puede cambiar aquí
            </small>
          </FormGroup>

          {showTipoCambio && (
            <FormGroup>
              <Label for="tipo_cambio">
                Tipo de Cambio ({fxCurrency} por 1 USD):
              </Label>
              <Input
                type="number"
                step="0.0001"
                min="0"
                name="tipo_cambio"
                placeholder="ej. 17 (vacío para usar la tasa mensual)"
                onChange={(e) => this.setState({
                  tipo_cambio: e.target.value === "" ? null : Number(e.target.value),
                })}
                value={this.state.tipo_cambio ?? ""}
              />
              <small className="form-text text-muted">
                {fxRowCurrency !== 'USD'
                  ? 'Opcional. Si lo capturas, esta partida se convierte a USD dividiendo entre este número. Vacío = tasa del mes de inicio del proyecto.'
                  : `Opcional. Si lo capturas, esta partida en USD se convierte a ${fxProjectCurrency} multiplicando por este número. Vacío = tasa del mes de inicio del proyecto.`}
              </small>
            </FormGroup>
          )}

          <FormGroup>
            <Label for="costo">Costo de Administracion:</Label>
            <h5>
              {costoCalculado > 0
                ? costoCalculado.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : '0.00'}
            </h5>
          </FormGroup>

          {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
          <Button color="primary" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Spinner size="sm" className="me-2" /> Guardando...
              </>
            ) : (
              'Guardar'
            )}
          </Button>
        </Form>
      </div>
    );
  }
}

export default AdminCursoFormCerrado;
